import useAnalytics from "hooks/useAnalytics";

import { ANALYTICS } from "./constants";

const useRoleAnalytics = () => {
  return useAnalytics({
    page: ANALYTICS.analyticsPage,
  });
};

export default useRoleAnalytics;
